import React from 'react';
import { Card, CardBody } from "reactstrap";
import Skeleton from "react-loading-skeleton";

function SkeletonPost({ cardsCount = 10 }) {
    return (
        <div className="post-skeleton-container">
            {Array(cardsCount)
                .fill()
                .map((_, index) => (
                    <Card 
                        key={index} 
                        className="shadow-sm mb-3 skeleton-card-post"
                        style={{
                            width: "100%", 
                            position: "relative",
                            border: "none"
                        }}
                    >
                        {/* Skeleton para a imagem */}
                        <div className="skeleton-image-wrapper">
                            <Skeleton 
                                height={260} 
                                style={{
                                    borderRadius: "4px 4px 0 0",
                                    lineHeight: "normal"
                                }} 
                            />
                        </div>
                        
                        <CardBody className="p-3 text-center">
                            {/* Skeleton para o título */}
                            <Skeleton 
                                height={20} 
                                width="90%" 
                                style={{ 
                                    margin: "8px auto",
                                    lineHeight: "normal"
                                }} 
                            />
                            
                            {/* Skeleton para o autor */}
                            <Skeleton 
                                height={16} 
                                width="70%" 
                                style={{ 
                                    margin: "4px auto",
                                    lineHeight: "normal"
                                }} 
                            />
                            
                            {/* Skeleton para informações adicionais (opcional) */}
                            <Skeleton 
                                height={14} 
                                width="60%" 
                                style={{ 
                                    margin: "8px auto 0",
                                    lineHeight: "normal"
                                }} 
                            />
                        </CardBody>
                    </Card>
                ))}
        </div>
    );
}

export default SkeletonPost;